/**
 * The reference's inline icons: the language glyph, the play/pause pair,
 * the sound pair and the enlarge arrows. Each pair is one SVG whose two
 * halves the stylesheet shows or hides from the button's `aria-pressed`,
 * so the icon can never disagree with the state the button announces.
 */

import type { ReactNode } from 'react';

const STROKE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function LanguageIcon(): ReactNode {
  return (
    <svg viewBox="0 0 24 24" {...STROKE} strokeWidth={1.7} aria-hidden="true">
      <path d="M3.5 6h9M8 4v2M5.5 9.5c1.2 2.7 3.3 4.9 5.8 6.4M10.5 9.5c-1 3.1-3.4 5.9-6.8 7.9" />
      <path d="M13 20.5l3.6-9.5 3.6 9.5M14.6 17.2h4" />
    </svg>
  );
}

export function PlayPauseIcon(): ReactNode {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path className="cs-ic-pause" d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" />
      <path className="cs-ic-play" d="M8 5.5v13l10-6.5z" />
    </svg>
  );
}

export function SoundIcon(): ReactNode {
  return (
    <svg viewBox="0 0 24 24" {...STROKE} strokeWidth={1.8} aria-hidden="true">
      <path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" />
      <path className="cs-ic-on" d="M15.5 9.5a3.5 3.5 0 0 1 0 5M18 7a7 7 0 0 1 0 10" />
      <path className="cs-ic-off" d="M16 9.5l4 5M20 9.5l-4 5" />
    </svg>
  );
}

export function EnlargeIcon(): ReactNode {
  return (
    <svg viewBox="0 0 24 24" {...STROKE} strokeWidth={1.8} aria-hidden="true">
      <path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" />
    </svg>
  );
}
